// extracted by mini-css-extract-plugin
export default {"sameHeight":"Main_sameHeight__D0Si-"};